module.exports = __webpack_public_path__ + "img/logo-衡阳中心医院.c72c4729.png";